'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Textarea = require('./Textarea');

Object.defineProperty(exports, 'Textarea', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Textarea).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/textarea/index.js
// module id = 276
// module chunks = 0